/**
 * Dashboard Setup Content — State 1 (unprovisioned user)
 *
 * Renders: setup card (pulsing ring + status text + contact) + news (full hero).
 * Hidden: search bar, app grid, pending tasks, recent activity.
 */

import { DashboardSetupCard } from "./DashboardSetupCard";
import { DashboardNews } from "./DashboardNews";

interface DashboardSetupContentProps {
  setupLabels: {
    title: string;
    description: string;
    contactEmail: string;
  };
  newsLabels: {
    news: string;
    newFeature: string;
    siteCanvas: string;
    siteCanvasDescription: string;
    trySiteCanvas: string;
  };
}

export function DashboardSetupContent({ setupLabels, newsLabels }: DashboardSetupContentProps) {
  return (
    <>
      {/* Setup Status Card */}
      <DashboardSetupCard
        title={setupLabels.title}
        description={setupLabels.description}
        contactEmail={setupLabels.contactEmail}
      />

      {/* News — full hero variant */}
      <DashboardNews labels={newsLabels} />
    </>
  );
}
